import React, { useEffect, useState } from 'react';
import { PageContent, PageSection } from '../../../common/styles/page';
import Tabs from 'common/components/Tabs';
import { useSearchParams } from 'react-router-dom';

const tabs = ['Organization', 'Categories', 'Rules'];

const OrgSettings = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchParams] = useSearchParams();

  const tab = Number(searchParams.get('tab'));
  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    }
  }, [tab]);

  return (
    <PageContent data-testid="admin-org-settings-page">
      <Tabs
        data-testid="admin-org-settings-nav"
        options={tabs}
        onSelect={(item: React.SetStateAction<number>) => setSelectedTab(item)}
        selected={selectedTab}
        borderbottom
      />

      {tabs[selectedTab] === 'Organization' && (
        <PageSection padright data-testid="admin-org-settings-content"></PageSection>
      )}
      {tabs[selectedTab] === 'Categories' && (
        <PageSection data-testid="admin-org-settings-content"></PageSection>
      )}
      {tabs[selectedTab] === 'Rules' && (
        <PageSection padtop data-testid="admin-org-settings-content"></PageSection>
      )}
    </PageContent>
  );
};
export default OrgSettings;
